import { render, staticRenderFns } from "./HtmlDisplay.vue?vue&type=template&id=1953e674&scoped=true&"
import script from "./HtmlDisplay.vue?vue&type=script&lang=ts&"
export * from "./HtmlDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./HtmlDisplay.vue?vue&type=style&index=0&id=1953e674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1953e674",
  null
  
)

export default component.exports